const state={
  title:'',
  second_id:'',
}
export default state;


// WEBPACK FOOTER //
// ./src/store/state.js